export const babybed = 8;
export const animal = 9;
export const dej = 12;
export const taxe = 0.99;

export const closeDate = []
export const BS = ["05/01-05/02", "09/03-02/04", "01/10-15/10", "02/11-18/12"];
export const MS = ["06/02-08/03", "03/04-30/04", "06/05-30/06", "16/10-01/11", "19/12-04/01"];
export const HS = ["01/05-03/05", "07/05-10/05", "13/05-17-05", "22/05-25/05", "01/07-30/09"];

export const services = [
    {
        id: 1,
        title: "Petit déjeuner",
        price: dej,
    },
    {
        id: 2,
        title: "Lit bébé",
        price: babybed,
    },
    {
        id: 3,
        title: "Animal",
        price: animal,
    },
    { 
        id: 4,
        title: "Micro-ondes à disposition",
        price: 0,
    }
];

export const translations = {
    fr: {
      bathroom: "Salle de bain",
      douche: "Douche",
      bain: "Baignoire",
      beds: "Lits",
      person: "Personne(s)",
      withTerrace: "Avec terrasse",
      lowSeason: "Basse saison",
      midSeason: "Moyenne saison",
      highSeason: "Haute saison",
      capacity: "Capacité",
      singleBed: "lit(s) simple",
      doubleBed: "lit(s) double"
    },
    en: {
      bathroom: "Bathroom",
      douche: "Shower",
      bain: "Bath",
      beds: "Beds",
      person: "Person(s)",
      withTerrace: "With terrace",
      lowSeason: "Low season",
      midSeason: "Mid season",
      highSeason: "High season",
      capacity: "Capacity",
      singleBed: "single bed(s)",
      doubleBed: "double bed(s)"
    }
  };
  